export default __webpack_public_path__ + "static/10-e574417b9c1eb514ac6f2831d349f22f.webp";